import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { SeverityTag } from '@src/app/components/status/types';
import { normalizeDictionaryValue } from '@src/app/utils';

import { REPORT_STATUS } from './constants';

@Component({
  selector: 'status',
  standalone: true,
  imports: [TagModule],
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusComponent {
  @Input() set value(value: boolean) {
    switch (value) {
      case false:
        this.severity = 'danger';
        break;

      case true:
        this.severity = 'success';
        break;

      default:
        this.severity = 'warning';
        break;
    }

    this.status = normalizeDictionaryValue(value ? 1 : 0, REPORT_STATUS);
  }

  status?: string;
  severity?: SeverityTag;
}
